import classNames from "classnames";
import React from "react";

interface PublicationToWebProps {
  publicationToWeb: boolean
  style?: React.CSSProperties
  size?: "small" | "big"
}

const PublicationToWebIcon = (props: PublicationToWebProps) => {
  const { publicationToWeb, style, size } = props;

  return <div className="s1_compositedicon tooltiptarget" title={publicationToWeb ? RESX.Planning.PublicationToWeb : RESX.Planning.NoPublicationToWeb} style={style}>
    <span className={classNames("icon-globe", {
      [size]: size !== undefined
    })}></span>
    {!publicationToWeb && <span className={classNames("icon-forbidden layered", {
      [size]: size !== undefined,
    })}></span>}
  </div>;
};

export default PublicationToWebIcon;